import React from 'react';
import { motion, useReducedMotion } from 'framer-motion';

// Shared by the live counter and the offline counter; no account or network hooks.
export const OFFLINE_SHIELD = '/assets/images/tasbeeh/shield_1.png';
export const counterBackground = theme => `/assets/images/tasbeeh/background${theme === 'dark' ? '_dark' : ''}.png`;

export default function CounterShield({ count, src = OFFLINE_SHIELD, onIncrement, label }) {
  const reduceMotion = useReducedMotion();
  return <button type="button" className="counter-shield-button" aria-label={label}
    onClick={event => { event.stopPropagation(); onIncrement(); }}>
    <motion.img id="shield-img" src={src} alt="" className="shield"
      onError={event => { if (!event.currentTarget.src.endsWith(OFFLINE_SHIELD)) event.currentTarget.src = OFFLINE_SHIELD; }}
      key={count} initial={reduceMotion ? false : { scale: 0.9 }} animate={{ scale: 1 }}
      transition={{ type: 'spring', stiffness: 300, damping: 20 }}/>
  </button>;
}
